import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { hasInstalledIntegrationFeature } from '@next-adapter/integration-runtime/has-installed-integration-feature.js'

export function validateIntegrationRequirements(
  loaded: LoadedSchema,
  config: ResolvedBetterstartConfig
): void {
  if (
    loaded.type === 'form' &&
    loaded.schema.mailchimp &&
    !hasInstalledIntegrationFeature(config, 'mailchimp')
  ) {
    throw new Error(
      `Form schema "${loaded.schema.name}" sets "mailchimp", but the mailchimp integration is not installed. Run \`betterstart add --integration mailchimp\` or remove the "mailchimp" property from the schema.`
    )
  }
}
